import { isTokenExpired } from './jwt';

const TOKEN_KEY = 'accessToken';

export function setToken(token: string, persistent = true): void {
  const storage = persistent ? window.localStorage : window.sessionStorage;
  storage.setItem(TOKEN_KEY, token);
}

export function clearToken(): void {
  window.localStorage.removeItem(TOKEN_KEY);
  window.sessionStorage.removeItem(TOKEN_KEY);
}

export function extractTokenFromUrl(): string | null {
  const parts = window.location.href.split('?token=');
  if (parts.length < 2) return null;
  const candidate = parts[1].split('&')[0];
  return candidate || null;
}

export function getToken(): string | null {
  const sessionToken = window.sessionStorage.getItem(TOKEN_KEY);
  if (sessionToken && !isTokenExpired(sessionToken)) {
    return sessionToken;
  }

  const localToken = window.localStorage.getItem(TOKEN_KEY);
  if (localToken && !isTokenExpired(localToken)) {
    return localToken;
  }

  const urlToken = extractTokenFromUrl();
  if (urlToken && !isTokenExpired(urlToken)) {
    return urlToken;
  }

  return null;
}
